import * as types from '../constants/Userdetails'

const login_initialState = {
  data: null,
  token: null,
  isLoading: false,
  loginUserPhoto: null,
  error: null,
  Status: null,
}

export default function loginUser(state = login_initialState, action) {
  switch (action.type) {
    case types.USER_LOGG_IN_REQUEST:
      return { ...login_initialState, isLoading: true }
    case types.USER_LOGG_IN_REQUEST_COMPLETED:
      return { ...state, data: action.payload, token: action.token, roleList:action.roleList, grantEnabled:action.grantEnabled, isLoading: false }
    case types.USER_LOGG_IN_REQUEST_ERROR:
      return { ...state, data: null, error: action.error, isLoading: false }
    case types.USER_LOGGED_OUT:
      // state = null;
      return login_initialState
    case types.USER_PREFFERED_TEAM:
      return { ...state, data: action.data }
    case types.USER_PHOTO_REQUEST:
      return { ...state, Status: true };
    case types.USER_PHOTO_REQUEST_COMPLETED:
      return { ...state, loginUserPhoto: action.data, Status: false };
    case types.USER_PHOTO_REQUEST_ERROR:
      return { ...state, loginUserPhoto: null, error: action.error, Status: false };
    default:
      return state
  }
}

const initialState = {
  Status: null,
  actionStatus: null,
  grantStatus: false,
  grantResult: false,
  apiPostResult: null,
  actionResult: null,
  UserdetailsList: null,
  Userdetails: null,
  CPStatus: null,
  CPResult: null,
}

export function userDetails(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_USER_REQUEST:
      return {
        ...initialState,
        actionResult: false,
        Status: true
      };
    case types.FETCH_USER_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true,
        Userdetails: action.data
      };
    case types.FETCH_USER_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false,
        Userdetails: action.error
      };
    case types.FETCH_USER_REQUEST_RESET:
      return {
        ...initialState
      };
    case types.FETCH_USER_LIST_REQUEST:
      return {
        ...initialState,
        actionResult: false,
        Status: true
      };
    case types.FETCH_USER_LIST_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true,
        UserdetailsList: action.data
      };
    case types.FETCH_USER_LIST_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false,
        UserdetailsList: action.error
      };
    case types.ADD_USER_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.ADD_USER_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true,
        Userdetails: action.data
      };
    case types.ADD_USER_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false,
        Userdetails: action.error
      };
    case types.ACTION_USER_REQUEST:
      return {
        ...state,
        actionResult: false,
        actionStatus: true
      };
    case types.ACTION_USER_REQUEST_COMPLETED:
      return {
        ...state,
        actionStatus: false,
        actionResult: true,
      };
    case types.ACTION_USER_REQUEST_ERROR:
      return {
        ...state,
        actionStatus: false,
        actionResult: false,
      };
    case types.GRANT_USER_REQUEST:
      return {
        ...state,
        grantStatus: true,
        grantResult: false
      };
    case types.GRANT_USER_REQUEST_COMPLETED:
      return {
        ...state,
        grantStatus: false,
        grantResult: true,
      };
    case types.GRANT_USER_REQUEST_ERROR:
      return {
        ...state,
        grantStatus: false,
        grantResult: false,
      };
    case types.DELETE_USER_ROLE_REQUEST:
      return {
        ...state,
        actionStatus: true,
        actionResult: false,
      };
    case types.DELETE_USER_ROLE_REQUEST_COMPLETED:
      return {
        ...state,
        actionStatus: false,
        actionResult: true,
      };
    case types.DELETE_USER_ROLE_REQUEST_ERROR:
      return {
        ...state,
        actionStatus: false,
      };
    case types.CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        CPStatus: true,
        CPResult: false,
      };
    case types.CHANGE_PASSWORD_REQUEST_COMPLETED:
      return {
        ...state,
        CPStatus: false,
        CPResult: true,
      };
    case types.CHANGE_PASSWORD_REQUEST_ERROR:
      return {
        ...state,
        CPStatus: false
      };
    default:
      return state;
  }
} 


// WEBPACK FOOTER //
// ./reducers/userdetails.js